import { PatientProps } from '../contexts/PatientContext';
import { makeError } from '../utils/error';
import { splitNameAndLastname } from '../utils/formatters';
import { removeMask } from '../utils/masks';

export type Patient = {
  firstName: string;
  lastName: string;
  document: string;
  holderDocument?: string;
  documentType: string;
  birthDate: string;
  phoneNumber: string;
  email: string;
  sex: string;
  isPregnant?: boolean;
  idPatientExt?: string;
};

export type PatientValidateRule = { holderDocument: string } & Omit<Patient, 'document'>;

export const GENDER = {
  M: 'Masculino',
  F: 'Feminino'
};

export function PatientRule(patientRule: PatientValidateRule) {
  return patientRule;
}

export const PatientScheduleBuilder = (name: string) => {
  const patient = {} as Patient;

  const { firstName, lastName } = splitNameAndLastname(name);
  patient.firstName = firstName;
  patient.lastName = lastName;

  const setDocument = (document: string, type: string) => {
    patient.document = document;
    patient.documentType = type.toUpperCase();
  };
  const setBirthDate = (birthDate: string) => (patient.birthDate = birthDate);
  const setPhone = (phone: string) => (patient.phoneNumber = phone);
  const setEmail = (email: string) => (patient.email = email);
  const setGender = (gender: string) => (patient.sex = gender === GENDER.M ? 'M' : 'F');
  const setIsPregnant = (isPregnant: boolean) => (patient.isPregnant = isPregnant);
  const setExternalId = (externalId: string) => (patient.idPatientExt = externalId);

  const checkPropertyError = () => {
    if (!patient.document && !patient.idPatientExt) makeError(`Missing document OR patientExternalId property `);

    if (patient.document && !patient.documentType) makeError(`Missing documentType property `);
    if (!patient.birthDate) makeError(`Missing birthDate property `);
    if (!patient.phoneNumber) makeError(`Missing phoneNumber property `);
    if (!patient.email) makeError(`Missing email property `);
    if (!patient.sex) makeError(`Missing sex property `);
  };

  const build = () => {
    checkPropertyError();
    return patient;
  };

  return {
    setDocument,
    setBirthDate,
    setPhone,
    setEmail,
    setGender,
    setIsPregnant,
    setExternalId,
    build
  };
};

export function makePatientRuleByPatientProps(patient: PatientProps) {
  const document = removeMask(patient.document);
  const phone = removeMask(patient.phone);
  const gender = patient.gender ? patient.gender : 'não informado';
  const { firstName, lastName } = splitNameAndLastname(patient.name);

  const patientRule = PatientRule({
    firstName,
    lastName,
    holderDocument: document,
    documentType: patient.documentType,
    birthDate: patient.birthDate,
    phoneNumber: phone,
    email: patient.email,
    sex: gender
  });

  if (patient.pregnant) patientRule.isPregnant = true;
  return patientRule;
}
